import L1 from "../../../../assets/images/l1.jpg";
import L2 from "../../../../assets/images/l2.png";
import L3 from "../../../../assets/images/l3.png";
import L4 from "../../../../assets/images/l4.jpg";
import L5 from "../../../../assets/images/l5.png";

import F1 from "../../../../assets/images/f1.png";
import F2 from "../../../../assets/images/f2.png";
import F3 from "../../../../assets/images/f3.png";
import F4 from "../../../../assets/images/f4.png";
import F5 from "../../../../assets/images/f5.png";
import F6 from "../../../../assets/images/f6.png";

import D1 from "../../../../assets/images/d1.png";
import D2 from "../../../../assets/images/d2.png";
import D3 from "../../../../assets/images/d3.png";
import D4 from "../../../../assets/images/d4.png";

export const SkillsLanguages = [
  {
    src: L1,
    title: "HTML 5",
  },
  {
    src: L2,
    title: "CSS 3",
  },
  {
    src: L3,
    title: "Javascript",
  },
  {
    src: L4,
    title: "Java",
    backgroundSize: "contain",
  },
  {
    src: L5,
    title: "Python",
  },
];

export const SkillsFrameworks = [
  {
    src: F1,
    title: "Moleculer",
  },
  {
    src: F2,
    title: "Angular",
  },
  {
    src: F3,
    title: "NestJS",
  },
  {
    src: F4,
    title: "ReactJS",
  },
  {
    src: F5,
    title: "ExpresJS",
    backgroundSize: "contain",
  },
  {
    src: F6,
    title: "Loopback",
  },
];

export const SkillsDevops = [
  {
    src: D1,
    title: "Docker",
  },
  {
    src: D2,
    title: "Gitlab",
    backgroundSize: "contain",
  },
  {
    src: D3,
    title: "Circle CI",
    backgroundSize: "contain",
  },
  {
    src: D4,
    title: "Kubernetes",
    backgroundSize: "contain",
  },
];
